import './Calendar.scss';
import Component from './Calendar.js';
export default Component;
